'use strict';

import { orderBy } from 'lodash';
import { DateTime, Settings } from 'luxon';

import { loadWidget } from '../utils/load-widget';
import simpleTimezone from '../../utils/simple-timezone';
import { getEvents } from '../../utils/api';

import { initialiseElement } from './../../modules/scroller';

const now = DateTime.now();

Settings.defaultZoneName = 'America/Chicago';

loadWidget('calendar-scroller', {
    data: function () {
        return {
            ViewModel: {
                Loading: true,
                Performances: [],
            }
        }
    },
    mounted: function () {
        getEvents().then(events => {
            events = events.filter(event => {
                return DateTime.fromISO(event.perf_date).plus({ hours: 2, minutes: 30 }) > now;
            });

            events = orderBy(events, 'perf_date');

            if (!events.length) {
                return; // No events
            }

            events.forEach(event => {
                if (!event.hide_on_homepage) {
                    let eventDate = DateTime.fromISO(event.perf_date);
                    let hasMinutes = false;

                    if (eventDate.toFormat('m') > 0) {
                        hasMinutes = true;
                    }

                    let eventTime = hasMinutes ? eventDate.toFormat('h:mma') : eventDate.toFormat('ha');

                    this.ViewModel.Performances.push({
                        Prefix: event.prefix,
                        Suffix: event.suffix,
                        Title: event.title,
                        Day: eventDate.toFormat('EEE'),
                        Month: `${eventDate.toFormat('MMM')} ${eventDate.toFormat('d')}`,
                        Time: `${eventTime.toLowerCase()} ${simpleTimezone(eventDate)}`,
                        Year: String(eventDate.year),
                        Link: event.event_page_url,
                        ProdSeasonNo: event.prod_season_no,
                        PerfNo: event.perf_no,
                    });
                }

            });

            this.ViewModel.Loading = false;
        }).finally(() => {
            let interval = setInterval(() => {
                const scroller = this.$el.querySelector('.calendar-scroller');

                if (!scroller) {
                    return;
                }

                initialiseElement(scroller);
                clearInterval(interval);
            }, 1000);
        });
    }
});